import { KeyValuePipe } from '@angular/common';
import { Component, computed, input, model } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { lucideChevronDown } from '@ng-icons/lucide';
import { HlmDropdownMenuImports } from '@spartan-ng/helm/dropdown-menu';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { hlm } from '@spartan-ng/helm/utils';
import { cva, VariantProps } from 'class-variance-authority';
import { ClassValue } from 'clsx';
import {
  ÉtatRéférentielLivrable,
  ÉtatRéférentielLivrableNom,
} from '../../../administration/gestion-référentiels/models/référentiel-livrable.model';

export const listVariants = cva('component-small-medium px-sm py-xs gap-xs flex w-fit items-center rounded-full', {
  variants: {
    variant: {
      [ÉtatRéférentielLivrable.NON_DEMARRE]: 'bg-feedback-warning-lightest text-feedback-warning-main',
      [ÉtatRéférentielLivrable.PRODUCTION_DEMARREE]: 'bg-feedback-informative-lightest text-feedback-informative-main',
      [ÉtatRéférentielLivrable.VALIDE_METIER]: 'bg-feedback-informative-lightest text-feedback-informative-main',
      [ÉtatRéférentielLivrable.VALIDE_SERVICE_FORMATION]:
        'bg-feedback-informative-lightest text-feedback-informative-main',
      [ÉtatRéférentielLivrable.VALIDE_CDM]: 'bg-feedback-positive-lightest text-feedback-positive-main',
      [ÉtatRéférentielLivrable.NON_CONCERNE]:
        'bg-components-background-neutral-main text-components-content-neutral-primary',
    },
  },
});

export type ChipVariants = VariantProps<typeof listVariants>;

@Component({
  selector: 'app-etat-referentiel-livrable',
  imports: [HlmDropdownMenuImports, HlmIconImports, KeyValuePipe],
  templateUrl: './etat-referentiel-livrable.component.html',
  providers: [provideIcons({ lucideChevronDown })],
})
export class EtatReferentielLivrableComponent {
  readonly etat = model.required<ÉtatRéférentielLivrable>();
  readonly peutModifier = input<boolean>(false);

  public readonly userClass = input<ClassValue>('', { alias: 'class' });

  protected readonly _computedClass = computed(() => hlm(listVariants({ variant: this.etat() }), this.userClass()));
  protected readonly label = computed(() => this.transformEnumToString(this.etat()));

  protected readonly etatReferentielLivrable = ÉtatRéférentielLivrableNom;

  transformEnumToString = (value: ÉtatRéférentielLivrable) => {
    const mapping: Record<ÉtatRéférentielLivrable, ÉtatRéférentielLivrableNom> = {
      [ÉtatRéférentielLivrable.NON_DEMARRE]: ÉtatRéférentielLivrableNom.NON_DEMARRE,
      [ÉtatRéférentielLivrable.PRODUCTION_DEMARREE]: ÉtatRéférentielLivrableNom.PRODUCTION_DEMARREE,
      [ÉtatRéférentielLivrable.VALIDE_METIER]: ÉtatRéférentielLivrableNom.VALIDE_METIER,
      [ÉtatRéférentielLivrable.VALIDE_SERVICE_FORMATION]: ÉtatRéférentielLivrableNom.VALIDE_SERVICE_FORMATION,
      [ÉtatRéférentielLivrable.VALIDE_CDM]: ÉtatRéférentielLivrableNom.VALIDE_CDM,
      [ÉtatRéférentielLivrable.NON_CONCERNE]: ÉtatRéférentielLivrableNom.NON_CONCERNE,
    };
    return mapping[value];
  };

  changeEtat(rawKey: string) {
    const key = rawKey as keyof typeof ÉtatRéférentielLivrable;
    this.etat.set(ÉtatRéférentielLivrable[key]);
  }
}
